import { render, staticRenderFns } from "./AdminDashboardTopJurisdiction.vue?vue&type=template&id=2df23081&"
import script from "./AdminDashboardTopJurisdiction.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardTopJurisdiction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports